import type { TemplateOnlyComponent } from '@ember/component/template-only';

export interface Signature {
  Args: {
    class?: string;
  };
  Element: SVGElement;
}

const WrBellIconComponent: TemplateOnlyComponent<Signature> = <template>
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
    class={{@class}}
    ...attributes
  >
    <path
      d='M14.5083 9.97403L14.0781 9.35065C13.9705 9.14286 13.8629 8.83117 13.8629 8.62338V5.92208C13.8629 5.92208 13.8629 5.92208 13.8629 5.81818V5.71429C13.8629 3.42857 12.0344 1.66234 9.7757 1.03896C9.56058 0.415584 8.80767 0 8.16231 0C7.51696 0 6.76405 0.415584 6.54893 1.03896C3.96751 1.66234 2.24657 3.42857 2.24657 5.71429V5.81818C2.24657 5.81818 2.24657 5.81818 2.24657 5.92208V8.51948C2.24657 8.83117 2.13901 9.03896 2.03145 9.24675L1.49365 9.97403C0.202945 11.8442 1.60121 14.3377 3.85995 14.3377H5.36578C5.68846 15.3766 6.87161 16 7.9472 16C9.02279 16 10.2059 15.3766 10.5286 14.3377H12.0344C14.4007 14.3377 15.799 11.8442 14.5083 9.97403ZM7.9472 14.5455C7.62452 14.5455 7.4094 14.4416 7.19428 14.3377H8.80767C8.59255 14.4416 8.26987 14.5455 7.9472 14.5455ZM12.0344 12.8831H3.96751C2.89192 12.8831 2.13901 11.6364 2.78436 10.8052L3.2146 10.0779C3.53728 9.66234 3.75239 9.03896 3.75239 8.51948V5.92208C3.75239 5.81818 3.75239 5.81818 3.75239 5.71429C3.75239 4.15584 5.0431 2.7013 7.08672 2.38961C7.51696 2.28571 7.73208 1.97403 7.73208 1.55844C7.73208 1.55844 7.83964 1.45455 7.9472 1.45455C8.05476 1.45455 8.16231 1.45455 8.16231 1.55844C8.16231 1.87013 8.37743 2.28571 8.80767 2.38961C10.7437 2.7013 12.142 4.15584 12.142 5.71429C12.142 5.81818 12.142 5.81818 12.142 5.92208V8.51948C12.142 9.03896 12.3571 9.66234 12.6798 10.0779L13.11 10.7013C13.8629 11.6364 13.2176 12.8831 12.0344 12.8831Z'
      fill='currentColor'
    />
  </svg>
</template>;

export default WrBellIconComponent;
